import { Component, Inject, OnInit } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { environment } from '../../../../../../../../environments/environment';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { AddStudentDto } from '../../../../../../models/students/dto/AddStudentDto';
import { AuthenticationService } from '../../../../../../services/authentication/authentication.service';
import { Lightbox } from 'ngx-lightbox';
import { SubjectDialogData } from './subject-dialog-data';
import { Subject } from '../../../../../../models/subjects/subject';
import { SubjectService } from '../../../../../../services/subject/subject.service';
import { MY_FORMATS } from '../../../../../../const/date-format';

@Component({
    selector: 'fuse-add-subject',
    templateUrl: './add-subject.component.html',
    styleUrls: ['./add-subject.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class AddSubjectComponent implements OnInit, AfterViewInit {

    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    subjectFormGroup;

    subjectNameControl;
    subjectDescriptionControl;

    public baseUri;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: SubjectDialogData,
        public dialogRef: MatDialogRef<AddSubjectComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        private authenticationService: AuthenticationService,
        private _lightbox: Lightbox,
        private subjectService: SubjectService,
    ) {
        console.log('data', data);
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri + '/images/';
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        console.log(this.data.subject);
        if (this.data.mode === 'view') {
            this.disable();
        }

        this.blockUI.stop();
    }

    disable() {
        this.subjectFormGroup.get('subjectNameControl').disable();
        this.subjectFormGroup.get('subjectDescriptionControl').disable();
    }

    ngAfterViewInit() {

    }

    initializeFormControlValidators() {
        this.subjectFormGroup = this.fb.group({
            subjectNameControl: ['', [Validators.required]],
            subjectDescriptionControl: ['', []]
        });
    }


    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        if (this.data.mode === 'new') {
            console.log('nuevo');
            this.add();
        } else {
            console.log('editar');
            this.edit();
        }
    }

    add() {
        this.blockUI.start(this.translationService.savingChanges);
        const subject = new Subject();

        subject.Name = this.data.subject.Name;
        subject.Description = this.data.subject.Description ? this.data.subject.Description : '';

        this.subjectService.add(subject).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                this.data.subject.Id = response.Id;
                this.subjectService.subjects.push(this.data.subject);
                this.subjectService.subjectObject[this.data.subject.Id] = this.data.subject;
                this.dialogRef.close(this.data.subject);
                this.translationService.translate('LABELS.CORRECTLY_ADDED', this.translationService.student, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    edit() {
        this.blockUI.start(this.translationService.savingChanges);

        const subject = new Subject();

        subject.Id = this.data.subject.Id;
        subject.Name = this.data.subject.Name;
        subject.Description = this.data.subject.Description ? this.data.subject.Description : '';

        this.subjectService.edit(subject).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                const index = this.subjectService.subjects.findIndex(st => st.Id === this.data.subject.Id);
                console.log('valor index', index);
                console.log(this.subjectService.subjects[index]);
                this.subjectService.subjects[index] = this.data.subject;
                this.subjectService.subjectObject[this.data.subject.Id] = this.data.subject;
                this.dialogRef.close(this.data.subject);
                this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.student, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/subjects/components/add-subejct/add-subject.component.ts